export default "__VITE_ASSET__DtWvtHZo__"